
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from '@/contexts/UserContext';
import { RECIPES } from '@/constants/queryKeys';
import { recipeService } from '@/services/recipe';

/**
 * Hook to get personal recipes created by the current user
 */
export const usePersonalRecipes = () => {
  const { isAuthenticated, user } = useUser();

  return useQuery({
    queryKey: [RECIPES, 'personal', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];
      
      // Get all recipes using the service, then filter for personal ones
      const allRecipes = await recipeService.getRecipes();
      
      // Filter to only show recipes created by the current user
      return allRecipes.filter(recipe => recipe.user_id === user.id);
    },
    enabled: isAuthenticated && !!user,
  });
};
